import React, { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import WhatsAppButton from "./WhatsAppButton";
import { buildWA } from "../data/catalog";

const LOGO_URL = "/images/logo.png";

const links = [
  { label: "Beranda", href: "#hero" },
  { label: "Tentang", href: "#tentang" },
  { label: "Katalog", href: "#katalog" },
  { label: "Testimoni", href: "#testimoni" },
];

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "py-3 bg-[#0B0B0B]/75 backdrop-blur-xl border-b border-white/5"
          : "py-5 bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between">
        <a
          data-testid="logo-home-link"
          href="#hero"
          className="flex items-center gap-3 group"
        >
          <img
            src={LOGO_URL}
            alt="DIGIFRIEND logo"
            className="w-10 h-10 rounded-lg object-cover ring-1 ring-purple-500/30 group-hover:ring-purple-500/70 transition"
          />
          <div className="leading-tight">
            <div className="font-display font-extrabold tracking-tight text-white text-lg">
              DIGI<span className="text-[#9B5BFF]">FRIEND</span>
            </div>
            <div className="text-[10px] text-white/45 tracking-[0.18em] uppercase">
              Digital Premium
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-${l.href.replace("#", "")}`}
              href={l.href}
              className="text-sm text-white/70 hover:text-white transition relative after:absolute after:left-0 after:-bottom-1 after:h-px after:w-0 after:bg-[#9B5BFF] hover:after:w-full after:transition-all"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex">
          <WhatsAppButton
            testId="header-cta-wa"
            href={buildWA("Konsultasi Produk Digital", "")}
            variant="primary"
            className="!py-2.5 !px-5 text-sm"
          >
            Hubungi Kami
          </WhatsAppButton>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          className="md:hidden p-2 rounded-lg text-white/85 hover:text-white hover:bg-white/5 transition"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile dropdown */}
      <div
        data-testid="mobile-menu"
        className={`md:hidden overflow-hidden transition-[max-height,opacity] duration-500 ${
          open ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="px-5 py-5 mx-5 mt-3 rounded-2xl glass">
          <div className="flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                data-testid={`mobile-nav-${l.href.replace("#", "")}`}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-white/80 hover:text-white py-1.5 text-sm"
              >
                {l.label}
              </a>
            ))}
            <WhatsAppButton
              testId="mobile-cta-wa"
              href={buildWA("Konsultasi Produk Digital", "")}
              variant="primary"
              fullWidth
              className="!py-3 mt-1 text-sm"
            >
              Hubungi via WhatsApp
            </WhatsAppButton>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
